export const environment = {
  production: true,
  environmentName: 'sportisimo',
  dirPrefix: 'sportisimo'
};
